module.exports = __webpack_public_path__ + "img/114.92639797.png";